import logo from 'assets/mask_logo_icon.svg?url';

import { AnimatedLogo, Circle,Wrapper } from './styled';

const FullScreenSpinner = ({ color }: { color?: string }) => {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-[rgba(16,_13,_11,_1)]">
      <Wrapper>
        <AnimatedLogo src={logo} alt="Loading..." />
        <Circle color={color} />
      </Wrapper>
    </div>
  );
};

export { FullScreenSpinner };
